import React from 'react';
import { useParams } from 'react-router-dom';
import { Logs } from 'components/common/logs';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';

export const SupplierLogs = React.memo(() => {
  const { id } = useParams();
  return (
    <HasAccess role={PERMISSIONS.suppliers.logs.read}>
      <div className={'logs-layout-container'}>
        <Logs entityName={'SUPPLIER'} id={id} />
      </div>
    </HasAccess>
  );
});
